import { Users } from "@graylog/server-api";
import { singleton } from "logic/singleton";
import createExternalStore from "logic/createExternalStore";
import isDeepEqual from "stores/isDeepEqual";
import Session from "logic/session/Session";
const createCurrentUser = () => {
  const store = createExternalStore({ currentUser: void 0, loadError: void 0 });
  let latestRequest = 0;
  const load = (username) => {
    latestRequest += 1;
    const request = latestRequest;
    return Users.get(encodeURIComponent(username)).then((user) => {
      const currentUser = user;
      if (request === latestRequest && !isDeepEqual(store.getState().currentUser, currentUser)) {
        store.setState({ currentUser });
      }
      return currentUser;
    });
  };
  const onSessionChange = () => {
    const { username } = Session.getState();
    latestRequest += 1;
    store.setState({ currentUser: void 0, loadError: void 0 });
    if (username) {
      const initialLoad = load(username);
      const request = latestRequest;
      initialLoad.catch((loadError) => {
        if (request === latestRequest) {
          store.setState({ loadError });
        }
      });
    }
  };
  Session.subscribe(onSessionChange);
  onSessionChange();
  return {
    getState: store.getState,
    subscribe: store.subscribe,
    reload: () => {
      const { username } = Session.getState();
      return username ? load(username) : Promise.resolve(void 0);
    }
  };
};
const CurrentUser = singleton("core.CurrentUser", createCurrentUser);
export default CurrentUser;
